import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import CardChoice from 'features/CardChoice';
import ProductChoice from 'features/ProductChoice';
import DriverLicenseStart from 'features/DriverLicense/DriverLicenseStart';
import ConsumerSearch from 'features/ConsumerSearch/ConsumerSearch';
import { RouteComponentProps } from 'react-router';
import CardSelector from 'features/CardSelector';

import { selectCreditApplication } from 'state/creditApplication';
import LoyaltyNumberError from 'features/Home/LoyaltyNumberError';

import useStartPageName from './useStartPageName';
import { useTrackApplicationStart } from 'hooks/useAnalytics';
import useWorkflow, { Step } from 'hooks/useWorkflow';
import useFieldCustomization from 'hooks/useFieldCustomization';

const DriverLicenseHome: React.FC<RouteComponentProps> = props => {
  const { steps } = useWorkflow();

  const startPageName = useStartPageName();
  useTrackApplicationStart(startPageName);

  const creditApplication = useSelector(selectCreditApplication);
  const { isRequired } = useFieldCustomization();

  const Component = useMemo(() => {
    switch (steps[0]) {
      case Step.CARD_CHOICE:
        return CardChoice;
      case Step.PRODUCT_CHOICE:
        return ProductChoice;
      case Step.CONSUMER_SEARCH:
        return ConsumerSearch;
      case Step.DRIVER_LICENSE_START:
        return DriverLicenseStart;
      case Step.CARD_SELECTOR:
        return CardSelector;
      default:
        //not supposed to happen
        throw new Error(`Unexpected start route ${steps[0]}`);
    }
  }, [steps]);

  if (isRequired('loyaltyNumber') && !creditApplication.loyaltyNumber) {
    return <LoyaltyNumberError />;
  } else {
    return <Component {...props} />;
  }
};

export default DriverLicenseHome;
